import type { Trace } from '@hotjar/webapp/features/Playbacks/types';

const DOUBLE_NEW_LINE = `\n\n`;
const TAB_CHAR = '\t';
const EMPTY_CONTENT = '';

export const getErrorTextToCopy = (
  errorText: string,
  trace: Trace | undefined,
  time: number,
  recordingLinkMessage: string,
): string => {
  const params = new URLSearchParams(window.location.search);

  params.set('startTime', time.toString());

  const recordingUrl = `${window.location.origin}${window.location.pathname}?${params.toString()}`;

  let traceText: string | undefined;
  if (trace) {
    traceText = trace
      .map((line) => TAB_CHAR + `${line.functionName} @ ${line.fileName}:${line.lineNumber}`)
      .join('\n');
  }

  // @TODO Provide a better copy when error text is undefined.
  return (
    errorText +
    (Boolean(traceText) ? DOUBLE_NEW_LINE + traceText : EMPTY_CONTENT) +
    DOUBLE_NEW_LINE +
    `${recordingLinkMessage}: ${recordingUrl}`
  );
};
